<template>
  <div id="adminContents">
    <ol class="breadcrumb">
      <li class="breadcrumb-item">{{ admin }}</li>
      <li class="breadcrumb-item active">
        <router-link :to="url" v-on:click.native="executeCancel">{{ contents }}</router-link>
      </li>
    </ol>
    <div class="container-fluid">
      <div class="card">
        <div class="tab-content noborder">
          <div class="tab-pane nopadding active" id="tabTable" role="tabpanel">
            <div class="card-body">
              <bootstrapTable
                :configurations="tableConfiguration"
                :datas="tableData"
                id="tableContents"
                ref="tableContents"
                :results="tableResult"
              ></bootstrapTable>
            </div>
          </div>
          <div class="tab-pane nopadding" id="tabDetail" role="tabpanel">
            <div class="card-header">
              <div class="row">
                <div class="col-6"><h4>{{ codeSelected }}</h4></div>
                <div class="col-6 text-right">
                  <label for="idLanguage" class="col-6 col-form-label">{{ lingua }}</label>
                  <select2
                    id="idLanguage"
                    :change="languageChange"
                    class="col-6 form-control"
                    :options="defaultLanguageOptions"
                    service="languages"
                    style="width:30%"
                    v-model="idLanguage"
                  ></select2>
                </div>
              </div>
            </div>
            <div class="card-body" style="padding:30px;">
              <div class="row">
                <div class="col-sm-12">
                  <h2>Elementi dinamici disponibili</h2>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-12">
                  <div class="div-container-tag"> 
                    <div class="div-list-tag" v-for="tag in tags" :key="tag.tag">
                      {{tag.tag}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card-body" style="padding:30px;">
              <div class="row">
                <div class="col-sm-12">
                  <label for="description" class="col-12 col-form-label" style="padding-left: 0px;margin-bottom: 0px;">Descrizione</label>
                  <input type="text" class="form-control" id="description" required="required" name="description" />
                </div>
              </div>
            </div>
            <div class="card-body" style="padding:30px;">
              <FroalaEditor
                :content="content"
                v-on:updateContenuto="updateContenuto"
                :tipoTemplate="tipoTemplate"
              ></FroalaEditor>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-danger" @click="confirmCancel"><i class="fa fa-times"></i>&nbsp;{{ cancel }}</button>
              <button type="button" class="btn btn-success" @click="confirmSave"><i class="fa fa-floppy-o"></i>&nbsp;{{ save }}</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BootstrapTable from "@/components/BootstrapTable.vue";
import FroalaEditor from "@/components/FroalaEditor.vue";
import Select2 from "@/components/Select2.vue";

export default {
  name: "adminContents",
  components: {
    BootstrapTable,
    FroalaEditor,
    Select2
  },
  data: function() {
    return {
      admin: dictionaryHelpers.getDictionary("Admin"),
      codeSelected: "",
      tipoTemplate: "Header",
      cancel: dictionaryHelpers.getDictionary("Cancel"),
      content: "",
      contents: dictionaryHelpers.getDictionary("Contents"),
      defaultLanguageOptions: {
        id: storageData.sIdLanguage(),
        text: storageData.sDescriptionLanguage()
      },
      idContentSelected: 0,
      idLanguage: storageData.sIdLanguage(),
      lingua: dictionaryHelpers.getDictionary("Language"),
      languageData: [],
      languageToSave: 0,
      tableConfiguration: [],
      tableData: [],
      tableResult: [],
      tags: [],
      save: dictionaryHelpers.getDictionary("Save"),
      url: window.location.pathname
    };
  },
  created() {
    var adminContents = this;

    spinnerHelpers.show();
    adminConfigurationServices.getFunctionality(function(result) {
      if (
        functionHelpers.isValued(result) &&
        functionHelpers.isValued(result.data)
      ) {
        adminContents.tableConfiguration = result.data.tablesConfigurations;
        adminContents.detailConfiguration =
          result.data.tabsConfigurations[0].pageConfigurations;
      }
      adminContents.loadTable();
    });
  },
  methods: {
    contentFormatter(value, row, index, field) {
      return (
        '<div class="container-fluid nopadding" style="width:80px;"><div class="row"><div class="col-1"><button class="btn btn-success" onclick="adminContents.__vue__.idContentSelected = ' +
        row.id +
        "; adminContents.__vue__.codeSelected = '" +
        row.code +
        '\'; adminContents.__vue__.onDetail();"><i class="fa fa-pencil" title="' +
        dictionaryHelpers.getDictionary("OpenDetail") +
        '"></button></div></div></div>'
      );
    },
    loadTable() {
      var adminContents = this;

      contentServices.getAll(function(result) {
        adminContents.tableData = result.data;
        spinnerHelpers.hide();
      });
    },
    loadContent() {
      var adminContents = this;
      this.tipoTemplate = this.codeSelected;
      if (functionHelpers.isValued(this.idContentSelected) && this.idContentSelected > 0 ) {
        contentServices.getByLanguage(this.idContentSelected, this.idLanguage,function(result) {
          adminContents.content = result.data.content;
          $('#description').val(result.data.description);
          spinnerHelpers.hide();
        });
      }
      
    },
    loadTagByTemplate(){
      var adminContents = this;
      if (functionHelpers.isValued(this.tipoTemplate)) {
        contentServices.getTagByType(this.tipoTemplate,function(result) {
          adminContents.tags = result.data;
          spinnerHelpers.hide();
        });
      }
    },
    onDetail() {
      spinnerHelpers.show();
      $("#tabTable").removeClass("active");
      $("#tabDetail").addClass("active");
      this.idLanguage = storageData.sIdLanguage();
      this.loadContent();
      this.loadTagByTemplate();
    },
    languageChange(value) {
      spinnerHelpers.show();
      var adminContents = this;
      var foundLanguageToSave = false;
      var contentToView;

      $.each(this.languageData, function(i, data) {
        if (data.idLanguage == adminContents.idLanguage) {
          foundLanguageToSave = true;
          data.content = adminContents.content;
        }

        if (data.idLanguage == value) {
          contentToView = data.content;
        }
      });

      if (!foundLanguageToSave) {
        this.languageData.push({
          idLanguage: this.idLanguage,
          content: this.content
        });
      }

      this.idLanguage = value;

      if (functionHelpers.isValued(contentToView)) {
        this.content = contentToView;
        spinnerHelpers.hide();
      } else {
        this.loadContent();
      }
    },
    updateContenuto(value) {
      this.content = value;
    },
    confirmCancel() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmCancel"))) {
        this.executeCancel();
      }
    },
    executeCancel() {
      spinnerHelpers.show();
      $("#tabTable").addClass("active");
      $("#tabDetail").removeClass("active");
      this.loadTable();
    },
    confirmSave() {
      if (confirm(dictionaryHelpers.getDictionary("ConfirmSave"))) {
        this.executeSave();
      }
    },
    executeSave() {
      spinnerHelpers.show();
      var adminContents = this;
      this.languageToSave = 0;
      var foundLanguageToSave = false;

      $.each(this.languageData, function(i, data) {
        if (data.idLanguage == adminContents.idLanguage) {
          foundLanguageToSave = true;
          adminContents.callSaveService(data.idLanguage, adminContents.content);
        } else {
          adminContents.callSaveService(data.idLanguage, data.content);
        }
      });

      if (!foundLanguageToSave) {
        adminContents.callSaveService(this.idLanguage, this.content);
      }
    },
    callSaveService(idLanguage, content) {
      var adminContents = this;
      this.languageToSave += 1;

      if (functionHelpers.isValued(content)) {
        var description = $('#description').val();
        contentServices.update(
          this.idContentSelected,
          this.codeSelected,
          idLanguage,
          content,
          description,
          function() {
            notificationHelpers.success(
              dictionaryHelpers.getDictionary("UpdateCompleted")
            );
            adminContents.checkSaveAllLanguage();
          },
          function() {
            adminContents.checkSaveAllLanguage();
          }
        );
      } else {
        contentServices.deleteLanguage(
          this.idContentSelected,
          idLanguage,
          function() {
            notificationHelpers.success(
              dictionaryHelpers.getDictionary("UpdateCompleted")
            );
            adminContents.checkSaveAllLanguage();
          },
          function() {
            adminContents.checkSaveAllLanguage();
          }
        );
      }
    },
    checkSaveAllLanguage() {
      this.languageToSave -= 1;

      if (this.languageToSave == 0) {
        this.executeCancel();
      }
    }
  }
};
</script>
<style scoped>
.div-container-tag{
  display:flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items:center;
}

.div-list-tag{
  border-radius: 3px;
    border: 3px solid #f0f0f0;
    background: #f0f0f0;
    font-size: 12px;
    color: #42B983;
    padding: 3px 5px;
    margin-right: 5px;
    margin-top: 10px;
    font-weight: bold;
    font-style: italic;
    box-shadow: 0px 3px 10px -5px rgba(0,0,0,0.3);
}
</style>
